import checkProductExists from './check-product-exists';
import getProductID from './get-product-id';

export default (wishlistProducts) => {
  let count_whishlist_items = 0;
  let count_notfound_items = 0;
  _.each(wishlistProducts, async (wishlistProduct) => {
    const product_exists = await checkProductExists(wishlistProduct.du);
    const wishlist_product_id = getProductID(wishlistProduct);
    // console.log(product_exists, window._swat, wishlistProduct.du);

    if (!product_exists) {
      count_notfound_items++;

      if (window._swat) {
        const remove_object = _.find(window.wishlist_products, { id: wishlist_product_id });

        if (typeof remove_object !== 'undefined') {
          window._swat.removeFromWishList(remove_object, () => {
            // console.log(`${wishlistProduct.du} doesn't exist, auto-removed from the wishlist`);
            $(`[data-cart-wishlist-item-id="${wishlist_product_id}"]`).remove();
          });
        }
      }
    }

    count_whishlist_items++;

    if (count_notfound_items && count_whishlist_items === wishlistProducts.length) {
      // console.log('reorganize grid');
      $('[data-cart-wishlist-item]').removeClass('new-row');
      let count_whishlist_rendered_item = 0;
      _.each($('[data-cart-wishlist-item]'), (item) => {
        if (count_whishlist_rendered_item % 4 === 0) {
          $(item).addClass('new-row');
        }

        count_whishlist_rendered_item++;
      });
    }
  });
};
